import { render, staticRenderFns } from "./BookingPaid.vue?vue&type=template&id=7290f9b0&scoped=true"
import script from "./BookingPaid.vue?vue&type=script&lang=ts"
export * from "./BookingPaid.vue?vue&type=script&lang=ts"
import style0 from "./BookingPaid.vue?vue&type=style&index=0&id=7290f9b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7290f9b0",
  null
  
)

export default component.exports